@let configurationFormValue = configurationForm();

<div class="login-flow__container">
  <div class="login-flow__info">
    <div class="login-flow__log-in-to">{{ 'login.flow.log-in-to' | translate }}</div>
    <span class="login-flow__organization-name">{{ configurationFormValue.value.organizationName }}</span>
    <kds-input elementId="username" hidden [componentFormControl]="configurationFormValue.controls.username" />
    {{ configurationFormValue.value.username }}
  </div>
  @if (loginConfiguration(); as loginConfiguration) {
    <div class="login-flow__local-login" (keyup.enter)="logIn()">
      <kds-input
        elementId="password"
        type="password"
        autocomplete="current-password"
        [label]="'login.flow.labels.password' | translate"
        [autoFocus]="true"
        [componentFormControl]="password"
      >
        <a
          kds-link
          kdsPrefetch
          [routerLink]="['/', ApplicationPath.CannotLogin, LoginRecoveryPath.ForgotPassword]"
          [queryParams]="{
            organizationName: configurationFormValue.value.organizationName,
            username: configurationFormValue.value.username,
          }"
          (keyup.enter)="$event.stopPropagation()"
        >
          {{ 'login.flow.forgot-password-link' | translate }}
        </a>
      </kds-input>
      <div class="login-flow__local-login-button">
        <kds-large-button
          [buttonText]="'login.flow.buttons.log-in' | translate"
          [loading]="logInLoading() || checkMfaLoading() || userInfoLoading()"
          (buttonClick)="logIn()"
        />
      </div>
    </div>
    @if (loginConfiguration.isSsoEnabled) {
      <div class="login-flow__separator">
        <span class="login-flow__separator-line"></span>
        <span class="login-flow__separator-text">{{ 'login.flow.separator-text' | translate }}</span>
        <span class="login-flow__separator-line"></span>
      </div>
      <div class="login-flow__sso-login">
        <kds-large-icon-button
          iconClass="fa-regular fa-shield-keyhole"
          colorScheme="secondary"
          [buttonText]="'login.flow.buttons.log-in-with-sso' | translate"
          (buttonClick)="logInWithThirdPartySSO()"
        />
      </div>
    }
    <div class="login-flow__back-button">
      <kds-large-button
        colorScheme="tertiary"
        [buttonText]="'login.flow.buttons.back' | translate"
        (buttonClick)="goToConfigurationStep()"
      />
    </div>
  }
</div>
